import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Feather, Library } from "lucide-react";
import PublicHeader from "./PublicHeader";

export default function LoginChoice() {
  const portals = [
    { label: "Reader", to: "/loginreader", icon: BookOpen, description: "Return to your reading circle, saved books, and orders." },
    { label: "Author", to: "/loginauthor", icon: Feather, description: "Manage your books, author website, and newsletters." },
    { label: "Publishing group", to: "/publishing-groups/login", icon: Library, description: "Manage your publishing group and its bookish community." },
  ];
  return <div className="min-h-screen bg-bookish-cream text-bookish-purple">
    <PublicHeader audience={null} />
    <main className="max-w-5xl mx-auto px-5 py-12 sm:py-20">
      <p className="text-center uppercase tracking-widest text-sm">Welcome back to the Circle</p>
      <h1 className="font-serif text-4xl text-center mt-3">Which account would you like to log in to?</h1>
      <p className="text-center mt-4 mb-9">Choose your portal to pick up where you left off.</p>
      <div className="grid gap-5 md:grid-cols-3">{portals.map(({ label, to, icon: Icon, description }) =>
        <Link key={to} to={to} className="block rounded-2xl border border-bookish-purple/20 bg-white p-7 shadow-sm hover:shadow-md hover:border-bookish-purple focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">
          <Icon aria-hidden="true" size={32} strokeWidth={1.4} />
          <h2 className="font-serif text-2xl mt-4">{label} login</h2>
          <p className="mt-3 leading-relaxed">{description}</p>
        </Link>
      )}</div>
      <p className="text-center mt-9"><Link to="/admin/login" className="inline-block underline py-3">Admin login</Link></p>
    </main>
  </div>;
}
